import React from 'react'
import { FacetGroupName } from '../../__generated__/fed-graphql-types'
import { useForm } from '../hocs/form.context'
import { StyledNewFiltersMobileContainer, StyledNewLeftColumn } from './search-form.styles'

import { ExpandableFilter } from '../../components/expandable-filter/expandable-filter'
import { NewBlankSection } from '../../components/blank-section/blank-section.component'
import { ExpandableGroupName, SortGroupName } from '../../components/expandable-filter/types'
import { YourSavedSearches } from '../../patterns/saved-searches/your-saved-searches'
import { expandableFilterDataMaker } from './expandable-filters'
import { defaultChannelFilterOrder } from './default-filter-order'
import { useCategoryTags, useChannel, useFlexibleFinanceFilters } from '../../hooks/use-abtest.hook'
import { getChannelSearchTypeKey, useIsLeisureOrTPF } from '../../utils/channel-utilities'
import { isTpf } from '@at/formatter-utils/lib/channel-utils/channel.util'
import { useIsLeasingSearch } from '../../utils/is-leasing-search'

export const allExpandableGroupNames = Object.keys({ ...FacetGroupName, ...SortGroupName }).map(
    (item) => item as ExpandableGroupName
)

export const SearchForm = () => {
    const { isSelected, hasSelected, queryFacetGroups, sortByDisplayText, totalResults } = useForm()
    const channel = useChannel()
    const isLeasing = useIsLeasingSearch()
    const channelSearchTypeKey = getChannelSearchTypeKey(channel, isLeasing)
    const rawFilterOrder = defaultChannelFilterOrder.get(channelSearchTypeKey) || []
    const defaultFilterOrder = useCategoryTags()
        ? rawFilterOrder
        : rawFilterOrder.filter((facet) => facet !== 'category_tag')
    const showFlexibleFinance = useFlexibleFinanceFilters()

    const expandableFilterData = expandableFilterDataMaker(
        isSelected,
        queryFacetGroups,
        sortByDisplayText,
        totalResults,
        hasSelected,
        channel,
        showFlexibleFinance
    )

    const enableIcons = !useIsLeisureOrTPF()
    const showSavedSearch = !isTpf(channel) && !isLeasing

    return (
        <StyledNewFiltersMobileContainer data-testid="search-form">
            <StyledNewLeftColumn>
                {showSavedSearch ? <YourSavedSearches /> : null}
                {defaultFilterOrder.map((facetGroupName, index) => {
                    const expandableFilter = expandableFilterData[facetGroupName]
                    if (expandableFilter.group) {
                        return (
                            <ExpandableFilter
                                key={index}
                                icon={enableIcons ? expandableFilter?.icon : null}
                                group={expandableFilter?.group}
                                singularColumn={expandableFilter?.singularColumn}
                                badge={expandableFilter?.badge}
                                alwaysOpen={expandableFilter?.alwaysOpen}
                            >
                                {expandableFilter?.children}
                            </ExpandableFilter>
                        )
                    } else {
                        return (
                            <NewBlankSection id={expandableFilter.title} key={index}>
                                {expandableFilter?.children}
                            </NewBlankSection>
                        )
                    }
                })}
            </StyledNewLeftColumn>
        </StyledNewFiltersMobileContainer>
    )
}
